<template>
  <div>
    <TopHeader code="know" />

    <section class="container-fluid uc-encyclopediasDetail">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link :to="{ name: 'KnowPoint' }" class="item"
                >百科</router-link
              >
              <router-link to="" class="item">详情</router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-24 col-sm-17">
            <section class="detail uc-mr10">
              <div class="title">
                <b>{{ model.title }}</b>
                <div class="number">
                  <img
                    src="../../assets/images/icon231.png"
                    class="uc-icon16"
                  />{{ model.reference_count }}次
                </div>
              </div>
              <div class="sub-title">定义</div>
              <div class="con line">
                <p>
                  {{ model.definition }}
                </p>
              </div>
              <div class="sub-title">描述</div>
              <div class="con line">
                <p>
                  {{ model.description }}
                </p>
              </div>
              <div class="sub-title">编辑者</div>
              <div class="con line">
                <p>
                  {{ model.create_user_name }} <br />
                  {{ model.create_time }}
                </p>
              </div>
              <!-- <div class="sub-title">所属公司/部门</div>
              <div class="con line">
                <p>集团</p>
              </div> -->
            </section>
          </div>

          <div class="col-24 col-sm-7">
            <section class="g-sideCourseList ">
              <div class="title">相关课程</div>
              <div class="content-empty" v-if="model.course_list.length == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div class="list">
                <div
                  class="item"
                  v-for="(item, index) in model.course_list"
                  :key="index"
                >
                  <router-link
                    :to="{
                      name: 'CourseDetails',
                      params: { id: item.id },
                    }"
                    class="img-box"
                  >
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/default-kc.png" />
                      </div>
                    </el-image>
                  </router-link>
                  <div class="con">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.name"
                    >
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <div class="txt">
                      {{ item.lecturer_name || '无讲师' }}
                    </div>
                    <div class="btm">
                      <span class="el-icon-time"> {{ item.period }}分钟 </span>
                      <span class="el-icon-view" style="float: right;">
                        {{ item.study_count }}人
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'KnowPointDetails',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      query: { id: this.$route.params.id },
      model: { course_list: {} },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getKnowPointDetails();
    },
    async getKnowPointDetails() {
      const response = await this.$api.knowpoint.getKnowPointDetails(
        this.query
      );
      this.model = response.data.data;
    },
  },
};
</script>
